document.addEventListener(
  "DOMContentLoaded",
  function () {
    if (
      document.getElementById(
        "Slide-template--15271230603403__16620877397429f7be-2"
      )
    ) {
      //select reference/parent node
      const paragraphList = document.querySelector(
        "#Slide-template--15271230603403__16620877397429f7be-2 .multicolumn-card__info .rte"
      );

      // create image node
      const checkMark = document.createElement("img");
      const imgURL =
        "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/check-mark-icon.png?v=1663611313";
      checkMark.src = imgURL;
      checkMark.alt = "check mark icon";

      paragraphList.children[0].outerHTML =
        '<div class="customListItem"> <div class="listImg">' +
        checkMark.outerHTML +
        ' </div> <div class="listPara">' +
        paragraphList.children[0].outerHTML +
        "</div> </div>";
      paragraphList.children[1].outerHTML =
        '<div class="customListItem"> <div class="listImg">' +
        checkMark.outerHTML +
        ' </div> <div class="listPara">' +
        paragraphList.children[1].outerHTML +
        "</div> </div>";
      paragraphList.children[2].outerHTML =
        '<div class="customListItem"> <div class="listImg">' +
        checkMark.outerHTML +
        ' </div> <div class="listPara">' +
        paragraphList.children[2].outerHTML +
        "</div> </div>";
    }

    if (
      document.querySelector(
        "#Slide-template--15271230603403__1661827086c8b32e4d-1.slideshow__slide .slideshow__text"
      )
    ) {
      //create image
      const fiveStarIcon = document.createElement("img");
      const iconURL =
        "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/custom-five-star-icon.png?v=1663627092";
      fiveStarIcon.src = iconURL;
      fiveStarIcon.alt = "custom five star icon";

      const slideshowHeader = document.querySelectorAll(
        ".slideshow__slide .banner__heading"
      );

      for (var i = 0; i < slideshowHeader.length; i++) {
        slideshowHeader[i].outerHTML =
          fiveStarIcon.outerHTML + "<br>" + slideshowHeader[i].outerHTML;
      }
    }

    if (
      document.querySelector(
        "#shopify-section-template--15271230603403__166208658339bccfd1 a.link"
      )
    ) {
      const arrowBtn = document.querySelector(
        "#shopify-section-template--15271230603403__166208658339bccfd1 a.link"
      ).outerHTML;

      const noArrowBtn1 = document.querySelector(
        "#shopify-section-template--15271230603403__1661826651e22b152a a.button"
      );
      const noArrowBtn2 = document.querySelector(
        "#shopify-section-template--15271230603403__1661827420d8d1dbc6 a.button"
      );
      const noArrowBtn3 = document.querySelector(
        "#shopify-section-template--15271230603403__1661827634b6362148 a.button"
      );

      noArrowBtn1.outerHTML = arrowBtn;
      noArrowBtn2.outerHTML = arrowBtn;
      noArrowBtn3.outerHTML = arrowBtn;
    }

    if (window.innerWidth <= 750) {
      //homepage
      if (
        document.getElementById(
          "Slider-template--15271230603403__1661827086c8b32e4d"
        )
      ) {
        const diabloImmortalMobileSRC =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/Diablo-Immortal-testimonial-mobile-background-image.jpg?v=1663623714";
        const genshinMobileSRC =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/Genshin-Impact-testimonial-mobile-background-image.jpg?v=1663623970";
        const punishingMobileSRC =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/Punishing-Gray-Raven-testimonial-mobile-background-image.jpg?v=1663624255";

        const slideshowImg = document.querySelectorAll(".slideshow__media img");

        slideshowImg[0].outerHTML =
          '<img src="' + diabloImmortalMobileSRC + '" />';
        slideshowImg[1].outerHTML = '<img src="' + genshinMobileSRC + '" />';
        slideshowImg[2].outerHTML = '<img src="' + punishingMobileSRC + '" />';
      }

      if (
        document.getElementById(
          "shopify-section-template--17847323525259__5742bc20-e39e-4012-85fd-9c733451f944"
        )
      ) {
        const holidayBanner =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-New-Years-banner-mobile.jpg?v=1735663095";
        const accountsForSale =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-accounts-for-sale-Banner-mobile.jpg?v=1743458434";
        const homeMainBanner =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-top-up-services-for-mobile-games-website-banner_f783fcdd-9d59-44bd-a71a-7adf9b58a90b.jpg?v=1680153244";
        const overwatchBanner =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-overwatch-website-banner-mobile.jpg?v=1713159281";
        const fortniteBanner =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-fortnite-website-banner-mobile.jpg?v=1733164084";
        const marvelBanner =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-marvel-rivals-banner-mobile.jpg?v=1738009240";

        // const topUpBannerMobile =
        //   "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-top-up-mobile-games-website-banner_dd8f90dd-c102-456e-a0db-69ef0e70ea7e.jpg?v=1680067024";

        const referalBannerMobile =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-get-10-give-10-Banner-squared.jpg?v=1713829281";

        const resourceAccountAd =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/Ad_Fresh_Accounts-2-mobile.jpg?v=1747009683";

        const fbBannerMobile =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-exclusive-discounts-and-giveaways-website-banner_2687b241-6305-4ed5-8680-82c8b2b999e0.jpg?v=1680067024";

        const slideshowImg = document.querySelectorAll(".slideshow__media img");

        slideshowImg[0].outerHTML = '<img src="' + resourceAccountAd + '" />';
        slideshowImg[1].outerHTML = '<img src="' + accountsForSale + '" />';
        slideshowImg[2].outerHTML = '<img src="' + homeMainBanner + '" />';
        slideshowImg[3].outerHTML = '<img src="' + marvelBanner + '" />';
        slideshowImg[4].outerHTML = '<img src="' + fortniteBanner + '" />';
      }

      //services page
      if (
        document.getElementById(
          "Slider-template--15274055729291__1661888909fb5b3b2b"
        )
      ) {
        const finalFantasyMobileSRC =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/Final-Fantasy-Brave-Exvius-testimonial-mobile-background-image.jpg?v=1663624816";
        const diabloImmortalMobileSRC =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/Diablo-Immortal-testimonial-mobile-background-image.jpg?v=1663623714";
        const genshinMobileSRC =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/Genshin-Impact-testimonial-mobile-background-image.jpg?v=1663623970";

        const slideshowImg = document.querySelectorAll(".slideshow__media img");

        slideshowImg[0].outerHTML =
          '<img src="' + finalFantasyMobileSRC + '" />';
        slideshowImg[1].outerHTML =
          '<img src="' + diabloImmortalMobileSRC + '" />';
        slideshowImg[2].outerHTML = '<img src="' + genshinMobileSRC + '" />';
      }

      //about page
      if (
        document.getElementById(
          "Slider-template--15274079453323__16618895333054674e"
        )
      ) {
        const finalFantasyMobileSRC =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/Final-Fantasy-Brave-Exvius-testimonial-mobile-background-image.jpg?v=1663624816";
        const diabloImmortalMobileSRC =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/Diablo-Immortal-testimonial-mobile-background-image.jpg?v=1663623714";
        const punishingMobileSRC =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/Punishing-Gray-Raven-testimonial-mobile-background-image.jpg?v=1663624255";

        const slideshowImg = document.querySelectorAll(".slideshow__media img");

        slideshowImg[0].outerHTML = '<img src="' + punishingMobileSRC + '" />';
        slideshowImg[1].outerHTML =
          '<img src="' + finalFantasyMobileSRC + '" />';
        slideshowImg[2].outerHTML =
          '<img src="' + diabloImmortalMobileSRC + '" />';
      }

      //collections page
      if (
        document.getElementById(
          "Slider-template--15271230668939__1661890838ccbb5e09"
        )
      ) {
        const finalFantasyMobileSRC =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/Final-Fantasy-Brave-Exvius-testimonial-mobile-background-image.jpg?v=1663624816";
        const genshinMobileSRC =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/Genshin-Impact-testimonial-mobile-background-image.jpg?v=1663623970";
        const punishingMobileSRC =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/Punishing-Gray-Raven-testimonial-mobile-background-image.jpg?v=1663624255";

        const slideshowImg = document.querySelectorAll(".slideshow__media img");

        slideshowImg[0].outerHTML = '<img src="' + genshinMobileSRC + '" />';
        slideshowImg[1].outerHTML = '<img src="' + punishingMobileSRC + '" />';
        // slideshowImg[2].outerHTML = '<img src="' + finalFantasyMobileSRC + '" />';
      }

      //buy now page
      if (
        document.getElementById("shopify-section-template--17847323558027__slideshow")
      ) {
        const holidayBanner =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-New-Years-banner-mobile.jpg?v=1735663095";
        const fbBannerMobile =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-exclusive-discounts-and-giveaways-website-banner_2687b241-6305-4ed5-8680-82c8b2b999e0.jpg?v=1680067024";
        const fortniteBanner =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-fortnite-website-banner-mobile.jpg?v=1733164084";
        const referalBannerMobile =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-get-10-give-10-Banner-squared.jpg?v=1713829281";
        const marvelBanner =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-marvel-rivals-banner-mobile.jpg?v=1738009240";
        const resourceAccountAd =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/Ad_Fresh_Accounts-2-mobile.jpg?v=1747009683";

        const slideshowImg = document.querySelectorAll(".slideshow__media img");

        slideshowImg[0].outerHTML = '<img src="' + resourceAccountAd + '" />';
        slideshowImg[1].outerHTML = '<img src="' + marvelBanner + '" />';
        slideshowImg[2].outerHTML = '<img src="' + fbBannerMobile + '" />';
        slideshowImg[3].outerHTML = '<img src="' + fortniteBanner + '" />';
        slideshowImg[4].outerHTML = '<img src="' + referalBannerMobile + '" />';
      }

      //accounts for sale collection page
      if (
        document.getElementById(
          "shopify-section-template--17847323132043__slideshow_t644Yg"
        )
      ) {
        const holidayBanner =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-New-Years-banner-mobile.jpg?v=1735663095";
        const fbBannerMobile =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-exclusive-discounts-and-giveaways-website-banner_2687b241-6305-4ed5-8680-82c8b2b999e0.jpg?v=1680067024";
        const fortniteBanner =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-fortnite-website-banner-mobile.jpg?v=1733164084";
        const referalBannerMobile =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-get-10-give-10-Banner-squared.jpg?v=1713829281";
        const marvelBanner =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-marvel-rivals-banner-mobile.jpg?v=1738009240";
        const resourceAccountAd =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/Ad_Fresh_Accounts-2-mobile.jpg?v=1747009683";

        const slideshowImg = document.querySelectorAll(".slideshow__media img");

        slideshowImg[0].outerHTML = '<img src="' + resourceAccountAd + '" />';
        slideshowImg[1].outerHTML = '<img src="' + marvelBanner + '" />';
        slideshowImg[2].outerHTML = '<img src="' + fbBannerMobile + '" />';
        slideshowImg[3].outerHTML = '<img src="' + fortniteBanner + '" />';
        slideshowImg[4].outerHTML = '<img src="' + referalBannerMobile + '" />';
      }

      //top up collection page
      if (
        document.getElementById(
          "shopify-section-template--17847323230347__slideshow_tHLxkw"
        )
      ) {
        const holidayBanner =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-New-Years-banner-mobile.jpg?v=1735663095";
        const fbBannerMobile =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-exclusive-discounts-and-giveaways-website-banner_2687b241-6305-4ed5-8680-82c8b2b999e0.jpg?v=1680067024";
        const fortniteBanner =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-fortnite-website-banner-mobile.jpg?v=1733164084";
        const referalBannerMobile =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-get-10-give-10-Banner-squared.jpg?v=1713829281";
        const marvelBanner =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-marvel-rivals-banner-mobile.jpg?v=1738009240";
        const resourceAccountAd =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/Ad_Fresh_Accounts-2-mobile.jpg?v=1747009683";

        const slideshowImg = document.querySelectorAll(".slideshow__media img");

        slideshowImg[0].outerHTML = '<img src="' + resourceAccountAd + '" />';
        slideshowImg[1].outerHTML = '<img src="' + marvelBanner + '" />';
        slideshowImg[2].outerHTML = '<img src="' + fbBannerMobile + '" />';
        slideshowImg[3].outerHTML = '<img src="' + fortniteBanner + '" />';
        slideshowImg[4].outerHTML = '<img src="' + referalBannerMobile + '" />';
      }

      //loyalty program page
      if (
        document.querySelector(
          "#shopify-section-template--16364472795275__1713755844083193eb"
        )
      ) {
        const loyaltyProgramMobileBanner =
          "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-loyalty-rewards-program-banner-mobile.jpg?v=1713822731";

        const loyaltyProgramBanner = document.querySelectorAll(
          "#shopify-section-template--16364472795275__1713755844083193eb .Joy-Hero-Banner_Image"
        );

        console.dir(loyaltyProgramBanner[0].style.background);

        loyaltyProgramBanner[0].style.background =
          'url("https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-loyalty-rewards-program-banner-mobile.jpg?v=1713824935")';

        // https://cdn.shopify.com/s/files/1/0601/9052/3531/files/PA-loyalty-rewards-program-banner-mobile.jpg?v=1713822731
      }
    }

    // Order fulfillment  status
    function updateRemainingTime() {
      const now = new Date();
      const currentHour = now.getHours();
      const currentMinute = now.getMinutes();
      const targetHour = 6; // 6 am Pacific Time

      if (currentHour >= 2 && currentHour < 6) {
        const remainingHours = targetHour - currentHour - 1;
        const remainingMinutes = 60 - currentMinute;
        document.getElementById(
          "remaining-time"
        ).textContent = `Order fulfillment starts at 6 AM PST, in about: ${remainingHours} hour(s) ${remainingMinutes} minute(s). Thank you for your patience.`;
        document.getElementById("remaining-time").style.color = "green";
      } else {
        document
          .getElementById("order-fulfillment-reminder")
          .classList.add("hidden");
      }
    }

    setInterval(updateRemainingTime, 60000); // Update every minute

    updateRemainingTime(); // Initial call to update remaining time


/*
| Add social icons on footer
*/
    

    // Select the footer social list
    const socialList = document.querySelector("ul.footer__list-social");

    if (socialList) {
        // Create the list item
        const listItem = document.createElement("li");
        listItem.className = "list-social__item";

        // Create the link element
        const discordLink = document.createElement("a");      
        discordLink.classList.add("link", "list-social__link");
        discordLink.href = "https://discord.com/invite/jrsgfaxFrn";
        discordLink.target = "_blank";

        // Create the image element
        const discordIcon = document.createElement("img");
        discordIcon.src = "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/discord-icon-white.png?v=1739972645";
        discordIcon.alt = "Discord";
        discordIcon.style.width = "20px";
        discordIcon.style.height = "20px";
        discordIcon.style.transition = "opacity";

        // Hover effect: Change image on hover
        const hoverImageSrc = "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/discord-icon-green.png?v=1739972710";
        discordLink.addEventListener("mouseover", function () {
            discordIcon.src = hoverImageSrc;
        });
        discordLink.addEventListener("mouseout", function () {
            discordIcon.src = "https://cdn.shopify.com/s/files/1/0601/9052/3531/files/discord-icon-white.png?v=1739972645";
        });

        // Append elements
        discordLink.appendChild(discordIcon);
        listItem.appendChild(discordLink);
        socialList.appendChild(listItem);
    } else {
        console.warn("Footer social list not found: Discord icon not added.");
    }

    
/*
| Add catalog link to product page
*/

  // Product title mapping to catalog links and URLs
  const productCatalogData = {
      "Honkai Star Rail Selective Starter Accounts": {
          text: "Click Here - Honkai Star Rail: Selective Starter Account Catalog",
          url: "http://chushi.jiankj.cn:81/Games/XQTD/index.php"
      },
      "Arknights Selective Starter Account": {
          text: "Click Here - Arknights: Selective Starter Account Catalog",
          url: "http://129.226.60.148/arknight-en/index.html"
      },
      "Pokémon TCG Pocket Selective Starter Accounts": {
          text: "Click Here - Pokémon TCG Pocket: Selective Starter Account Catalog 1",
          url: "http://chushi.jiankj.cn:81/games/ptcgp/index.php"
      },
      "NIKKE: Goddess of Victory Selective Starter Account": {
          text: "Click Here - NIKKE: Selective Starter Account Catalog",
          url: "http://my.jiankj.cn:81/Games/NIKKE/index.php"
      },
      "Raid Shadow Legends Selective Starter Accounts": {
          text: "Click Here: RSL Starter Accounts Catalog 1",
          url: "https://www.ak07.cn/game/"
      },
      "Epic Seven Selective Starter Accounts": {
          text: "Click Here: Epic Seven Starter Accounts Catalog 1",
          url: "http://show898.com/xk/gjdqn"
      },
      "Solo Leveling Selective Starter Accounts": {
          text: "Click Here: Solo Leveling Starter Accounts Catalog 1",
          url: "http://show898.com/xk/wdzsj",
          text2: "Click Here: Solo Leveling Starter Accounts Catalog 2",
          url2: "http://my.jiankj.cn:81/Games/SLA/index.php"
      },
      "Zenless Zone Zero Selective Starter Accounts": {
          text: "Click Here: Zenless Zone Zero Starter Account Catalog 1",
          url: "http://jdwlgame.com/zzz/"
      },
      "Wuthering Waves Selective Starter Accounts": {
          text: "Click Here: Wuthering Waves Starters Catalog 1",
          url: "http://jdwlgame.com/whglobal/",
          text2: "Click Here: Wuthering Waves Starters Catalog 2",
          url2: "http://bssy.top/index/mc/#account-search-href",
          text3: "Click Here: Wuthering Waves Starters Catalog 3",
          url3: "http://bssy.top/index/mc/#account-href"
      }
  };

    // Check if the page contains a recognized product title
    const productTitle = document.querySelector(".product__title h1");
    if (!productTitle || !(productTitle.textContent.trim() in productCatalogData)) {
        // console.warn("Product title does not match any known products: Script will not execute.");
        return;
    }

    // Add to Cart button selector
    const addToCartButton = document.querySelector("#product-form-template--15271230570635__main button.product-form__submit");
    
    if (addToCartButton) {
      
      if (productTitle.innerText === "Solo Leveling Selective Starter Accounts") {
        
        // Create the 1st link element
        const catalogLink1 = document.createElement("a");
        catalogLink1.href = productCatalogData[productTitle.textContent.trim()].url;
        catalogLink1.textContent = productCatalogData[productTitle.textContent.trim()].text;
        catalogLink1.target = "_blank";
        catalogLink1.style.display = "block";
        catalogLink1.style.color = "red";
        catalogLink1.style.fontSize = "26px";
        catalogLink1.style.fontWeight = "bold";
        catalogLink1.style.lineHeight = "35px";
        catalogLink1.style.textDecoration = "underline";
        catalogLink1.style.marginBottom = "10px";
        catalogLink1.style.paddingBottom = "10px";
        catalogLink1.style.textAlign = "left";

        // Insert the 1st link above the Add to Cart button
        addToCartButton.parentNode.insertBefore(catalogLink1, addToCartButton);

        // Create the 2nd link element
        const catalogLink2 = document.createElement("a");
        catalogLink2.href = productCatalogData[productTitle.textContent.trim()].url2;
        catalogLink2.textContent = productCatalogData[productTitle.textContent.trim()].text2;
        catalogLink2.target = "_blank";
        catalogLink2.style.display = "block";
        catalogLink2.style.color = "red";
        catalogLink2.style.fontSize = "26px";
        catalogLink2.style.fontWeight = "bold";
        catalogLink2.style.lineHeight = "35px";
        catalogLink2.style.textDecoration = "underline";
        catalogLink2.style.marginBottom = "10px";
        catalogLink2.style.paddingBottom = "10px";
        catalogLink2.style.textAlign = "left";

        // Insert the 2nd link above the Add to Cart button        
        addToCartButton.parentNode.insertBefore(catalogLink2, addToCartButton);
        return;
    }

      else if (productTitle.innerText === "Wuthering Waves Selective Starter Accounts") {      
        
        // Create the 1st link element
        const catalogLink1 = document.createElement("a");
        catalogLink1.href = productCatalogData[productTitle.textContent.trim()].url;
        catalogLink1.textContent = productCatalogData[productTitle.textContent.trim()].text;
        catalogLink1.target = "_blank";
        catalogLink1.style.display = "block";
        catalogLink1.style.color = "red";
        catalogLink1.style.fontSize = "26px";
        catalogLink1.style.fontWeight = "bold";
        catalogLink1.style.lineHeight = "35px";
        catalogLink1.style.textDecoration = "underline";
        catalogLink1.style.marginBottom = "10px";
        catalogLink1.style.paddingBottom = "10px";
        catalogLink1.style.textAlign = "left";

        // Insert the 1st link above the Add to Cart button
        addToCartButton.parentNode.insertBefore(catalogLink1, addToCartButton);

        // Create the 2nd link element
        const catalogLink2 = document.createElement("a");
        catalogLink2.href = productCatalogData[productTitle.textContent.trim()].url2;
        catalogLink2.textContent = productCatalogData[productTitle.textContent.trim()].text2;
        catalogLink2.target = "_blank";
        catalogLink2.style.display = "block";
        catalogLink2.style.color = "red";
        catalogLink2.style.fontSize = "26px";
        catalogLink2.style.fontWeight = "bold";
        catalogLink2.style.lineHeight = "35px";
        catalogLink2.style.textDecoration = "underline";
        catalogLink2.style.marginBottom = "10px";
        catalogLink2.style.paddingBottom = "10px";
        catalogLink2.style.textAlign = "left";

        // Insert the 2nd link above the Add to Cart button        
        addToCartButton.parentNode.insertBefore(catalogLink2, addToCartButton);

        // Create the 3rd link element
        const catalogLink3 = document.createElement("a");
        catalogLink3.href = productCatalogData[productTitle.textContent.trim()].url3;
        catalogLink3.textContent = productCatalogData[productTitle.textContent.trim()].text3;
        catalogLink3.target = "_blank";
        catalogLink3.style.display = "block";
        catalogLink3.style.color = "red";
        catalogLink3.style.fontSize = "26px";
        catalogLink3.style.fontWeight = "bold";
        catalogLink3.style.lineHeight = "35px";
        catalogLink3.style.textDecoration = "underline";
        catalogLink3.style.marginBottom = "10px";
        catalogLink3.style.paddingBottom = "10px";
        catalogLink3.style.textAlign = "left";

        // Insert the 3rd link above the Add to Cart button        
        addToCartButton.parentNode.insertBefore(catalogLink3, addToCartButton);
        return;
    }
        // Create the link element
        const catalogLink1 = document.createElement("a");
        catalogLink1.href = productCatalogData[productTitle.textContent.trim()].url;
        catalogLink1.textContent = productCatalogData[productTitle.textContent.trim()].text;
        catalogLink1.target = "_blank";
        catalogLink1.style.display = "block";
        catalogLink1.style.color = "red";
        catalogLink1.style.fontSize = "26px";
        catalogLink1.style.fontWeight = "bold";
        catalogLink1.style.lineHeight = "35px";
        catalogLink1.style.textDecoration = "underline";
        catalogLink1.style.marginBottom = "10px";
        catalogLink1.style.paddingBottom = "10px";
        catalogLink1.style.textAlign = "left";

        // Insert the link above the Add to Cart button
        addToCartButton.parentNode.insertBefore(catalogLink1, addToCartButton);
    }


    
    
  },
  false
);
